import React from 'react'

import { RiskUnitType } from '..'

interface IAttributeSelectorProps {
  attributeList: Array<{
    attribute: string
    displayUnit: string
    unit: RiskUnitType
  }>
  selectedAttribute: string | undefined
  isRiskDensityEnabled: boolean
  setSelectedAttribute: (attribute: string) => void
  children: React.ReactNode
}

interface IAttributeButtonProps {
  isSelected: boolean
  isDisabled: boolean
  onClick: () => void
  children: React.ReactNode
}

const AttributeButton = ({
  isSelected,
  isDisabled,
  onClick,
  children
}: IAttributeButtonProps) => {
  return (
    <button
      type='button'
      className={[
        'block px-4 py-2 w-full',
        'text-left font-semibold',
        isDisabled ? 'cursor-not-allowed bg-gray-500' : 'bg-lighthouseBlue',
        isSelected ? 'italic bg-opacity-30' : 'opacity-50 bg-opacity-20'
      ].join(' ')}
      onClick={onClick}
      disabled={isDisabled}
    >
      {children}
    </button>
  )
}

export const AttributeSelector = ({
  attributeList,
  selectedAttribute,
  isRiskDensityEnabled,
  setSelectedAttribute,
  children
}: IAttributeSelectorProps) => {
  return (
    <div className='tracking-tight'>
      <div className='mb-10 font-bold text-blue-navy uppercase'>{children}</div>
      <div>
        <div className='rounded overflow-hidden'>
          {attributeList.map((attribute) => {
            return (
              <AttributeButton
                key={attribute.attribute}
                isSelected={selectedAttribute === attribute.unit}
                isDisabled={
                  attribute.unit === RiskUnitType.RiskDensity &&
                  !isRiskDensityEnabled
                }
                onClick={() => setSelectedAttribute(attribute.unit)}
              >
                <>
                  {attribute.attribute}
                  {attribute.displayUnit && (
                    <span className='ml-1'>
                      (<span className='italic'>{attribute.displayUnit}</span>
                      <span className='ml-0.5'>)</span>
                    </span>
                  )}
                </>
              </AttributeButton>
            )
          })}
        </div>
      </div>
    </div>
  )
}
